"use client";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { PersianNum } from "@/util/tools/PersianNum";
import { useParams, useRouter } from "next/navigation";
import { ParseUrl, ProdProductIdentity } from "../product";
import { PriceAttribute } from "../tools";
import SellButton from "./SellButton";

interface AttributePricesProps {
  data: ProdProductIdentity[];
  checkData: PriceAttribute[];
  url: ParseUrl[];
}

const AttributePrices = ({ data, checkData, url }: AttributePricesProps) => {
  const router = useRouter();
  const path = useParams();

  const getWarehouseAndProperties = () => {
    const check = data.filter(
      (product) =>
        product.ProdProperties[0].Attribute.id === url[0].a &&
        product.ProdProperties[1].Attribute.id === url[1].a
    );
    const result = check.map((i) => {
      const ProductId = i.ProductId;
      const property: { attr: string; property: string }[] = [
        {
          attr: i.ProdProperties[0].Attribute.attribute_name,
          property: i.ProdProperties[0].Property.property_name,
        },
        {
          attr: i.ProdProperties[1].Attribute.attribute_name,
          property: i.ProdProperties[1].Property.property_name,
        },
      ];
      const available = i.Warehouses[0].warehouse_available;
      const ProductIdentityId = i.Warehouses[0].ProductIdentityId;
      return {
        ProductId,
        available,
        property,
        ProductIdentityId,
        warehouse_price: i.Warehouses[0].warehouse_price,
        warehouse_discount: i.Warehouses[0].warehouse_discount,
      };
    });
    return result[0];
  };
  const checkSellButton = getWarehouseAndProperties();

  const DiscountShow = ({
    price,
    discount,
  }: {
    price: number;
    discount: number;
  }) => (
    <div className="flex items-center">
      <PriceShow prices={discount} />
      <div className="flex items-center text-slate-600 mx-2">
        <p className="line-through">{PersianNum(price)}</p>
        <span className="text-sm">تومان</span>
      </div>
    </div>
  );

  const PriceShow = ({ prices }: { prices: number }) =>
    prices ? (
      <div className="flex items-center">
        <p className="text-red-700 dark:text-slate-700 font-bold text-xl">
          {PersianNum(prices)}
        </p>
        <span className="text-red-700 text-lg mr-1 dark:text-slate-700">تومان</span>
      </div>
    ) : null;

  const handleSelectChange = (
    propertyId: number,
    attributeId: number,
    index: number
  ) => {
    const newValueAttribute = [propertyId, attributeId];
    const data = url.map((i) => {
      return [i.p, i.a];
    });
    data[index] = newValueAttribute;
    router.push(`/product/${path.prod}?attri=${JSON.stringify(data)}`);
  };

  return (
    <div>
      {checkData.map((item, index) => {
        return (
          <div key={index} className="flex items-center my-1">
            <p className="w-10">{item.property.property_name}:</p>
            <Select
              defaultValue={url[index].a.toString()}
              onValueChange={(e) =>
                handleSelectChange(item.property.id, Number(e), index)
              }
            >
              <SelectTrigger style={{ direction: "rtl" }} className="w-[160px]">
                <SelectValue placeholder="انتخاب کنید" />
              </SelectTrigger>
              <SelectContent style={{ direction: "rtl" }}>
                <SelectGroup>
                  {item.attribute.map((attr) => (
                    <SelectItem key={attr.id} value={attr.id.toString()}>
                      {attr.attribute_name}
                    </SelectItem>
                  ))}
                </SelectGroup>
              </SelectContent>
            </Select>
          </div>
        );
      })}
      {checkSellButton ? (
        <div>
          <div className="flex items-center justify-between w-full fixed bottom-0 left-0 right-0 max-w-[1360px] mx-auto bg-white border rounded-lg z-50 px-2">
            <SellButton
              ProductId={checkSellButton.ProductId}
              ProductIdentityId={checkSellButton.ProductIdentityId}
              available={checkSellButton.available}
              property={checkSellButton.property}
            />

            {checkSellButton.warehouse_discount === 0 ? (
              <PriceShow prices={checkSellButton.warehouse_price} />
            ) : (
              <DiscountShow
                discount={checkSellButton.warehouse_discount}
                price={checkSellButton.warehouse_price}
              />
            )}
          </div>
        </div>
      ) : (
        <div className="flex justify-between items-center p-2">
          <p className="text-red-700 dark:text-slate-700  font-bold">
            یک رنگ یا سایز دیگر انتخاب کنید
          </p>
        </div>
      )}
    </div>
  );
};

export default AttributePrices;
